import { createSelector } from 'reselect';
import { values, get, compact, uniq } from 'lodash';

import { getCurrentAppointment } from 'modules/appointmentInfo/selectors/currentAppointment';
import { getAppointmentsByQueueType } from './appointmentsByQueueType';


export const getGroupAppointmentsIds = createSelector(
  getAppointmentsByQueueType,
  getCurrentAppointment,
  ({ entities }, currentAppointment) => {
    const currentAppointmentGroupId = get(currentAppointment, 'group.groupId');

    const Ids = values(entities).reduce((acc, { group }) => {
      return [...acc, get(group, 'groupId')];
    }, currentAppointmentGroupId ? [currentAppointmentGroupId] : []);

    return uniq(compact(Ids));
  },
);
